import { useCallback } from 'react';

import { useApolloClient } from '@apollo/client/react';
import log from 'loglevel';

import { useToast } from '@admin-platform/ui/components';

import { parseGraphQLErrorForUser } from '../utils/normalizeGraphqlError';

/**
 * Hook that provides a function to clear the Apollo Client cache
 * Useful for clearing frontend cached data
 */
export function useClearApolloCache(): () => Promise<void> {
  const apolloClient = useApolloClient();
  const toast = useToast();

  return useCallback(async () => {
    try {
      await apolloClient.clearStore();
    } catch (error) {
      const userFriendlyMessage = parseGraphQLErrorForUser(error);
      toast(userFriendlyMessage, 'error');
      log.error('Failed to clear Apollo cache:', error);
    }
  }, [apolloClient, toast]);
}
